import { SOFT_VERSION } from 'www/vue_components/common/SoftVersionIcon/constants'

function getListBenefits({ softVersion, isLpuPage }) {
  const isStandard = softVersion === SOFT_VERSION.standard
  const isPro = softVersion === SOFT_VERSION.pro
  const isUltima = softVersion === SOFT_VERSION.ultima

  return [
    `может обновлять данные о ${isLpuPage ? 'врачах' : 'себе'}`,
    'может отвечать на отзывы',
    (isPro || isStandard || isUltima) && isLpuPage ? 'может писать об акциях и скидках' : '',
    isPro || isUltima ? 'отключает на своей странице рекламу' : '',
    isPro || isStandard || isUltima ? 'отслеживает эффективность страницы' : '',
    isUltima && isLpuPage ? 'может подключать сервисы сквозной аналитики, работающие с МедФлексом' : '',
    isUltima && !isLpuPage ? 'может публиковать свои контакты' : '',
  ].filter(n => n)
}

export default getListBenefits
